export const appTopUps = {
  name: 'Top-Up |||| Top-Ups',
  fields: {
    id: 'Transaction ID',
    user: 'User',
    userId: 'User ID',
    userName: 'Name',
    userEmail: 'Email',
    amount: 'Amount',
    paymentMethod: 'Payment method',
    status: 'Status',
    timestamp: 'Date',
    referenceType: 'Reference type',
    referenceId: 'Reference ID',
    adminNotes: 'Admin notes',
    actions: 'Actions',
  },
  statuses: {
    pending: 'Pending',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
    refunded: 'Refunded',
  },
  filters: {
    search: 'Search (email / phone / name)',
    status: 'Status',
    statusAll: 'All',
    fromDate: 'From',
    toDate: 'To',
    today: 'Today',
    thisWeek: 'This week',
    thisMonth: 'This month',
  },
  summary: {
    today: 'Today',
    thisWeek: 'This week',
    thisMonth: 'This month',
    pendingFailed: 'Pending / Failed',
    transactions: 'transactions',
    refundedToday: 'Refunded today',
    errorTitle: 'Unable to load top-up summary',
    retry: 'Retry',
  },
  actions: {
    refund: 'Refund',
    refresh: 'Refresh',
    export: 'Export',
    exportSuccess: 'Export downloaded',
    exportFailed: 'Export failed',
  },
  show: {
    title: 'Top-up detail',
    sectionTopUpInfo: 'Top-up information',
    sectionUser: 'User',
    sectionPaymentDetails: 'Payment details',
    sectionRefund: 'Refund',
    refundHint:
      "Return the full amount to the user's original payment method via BBMSL and deduct from their wallet.",
  },
  refund: {
    title: 'Refund top-up',
    topUpAmount: 'Top-up amount',
    currentBalance: 'Current wallet balance',
    projectedBalance: 'Projected balance after refund',
    spentWarningTitle: 'User has spent part of this top-up',
    spentWarningBody:
      'Wallet balance will go negative. The user must top up again before their next charging session. Confirm you still want to proceed?',
    gatewayNote:
      "BBMSL will be called to return the full amount to the user's original payment method.",
    reason: 'Reason (required)',
    cancel: 'Cancel',
    confirm: 'Confirm refund',
    confirmNegative: 'Refund anyway',
    success: 'Refund processed successfully',
    failed: 'Refund failed',
    balanceUnknownTitle: 'Unable to fetch current wallet balance',
    balanceUnknownBody:
      'The projected balance cannot be calculated. Please close this dialog and retry, or investigate the API error before proceeding.',
  },
};
